var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardDecor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 64,
    viewBox: "0 0 125 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.58172 0 0 3.58172 0 8V64C0 59.5817 3.58172 56 8 56H75.8831C78.4667 56 80.8912 54.7523 82.3929 52.6499L117.607 3.35009C119.109 1.24773 121.533 0 124.117 0H8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardDecor);
export default __webpack_public_path__ + "static/media/card-decor.75e908f9d712d43d9eb7332bbe48e0d0.svg";
export { ForwardRef as ReactComponent };